import {getConfig, once} from './core.js';

let stockOnly;

export function isStockOnly() {
	if (stockOnly === undefined) {
		stockOnly = getConfig().colorStockFilter?.enabled !== false;
	}
	return stockOnly;
}

function syncControl(control) {
	const enabled = isStockOnly();
	if (control.matches('input[type="checkbox"]')) {
		control.checked = enabled;
	} else {
		control.setAttribute('aria-pressed', String(enabled));
		control.classList.toggle('active', enabled);
	}
}

function syncControls() {
	document.querySelectorAll('[data-color-stock-toggle]').forEach(syncControl);
}

async function persist(enabled) {
	const url = getConfig().colorStockFilter?.url;
	if (!url) {
		return;
	}
	const target = new URL(url, window.location.href);
	target.searchParams.set('enabled', enabled ? '1' : '0');
	const response = await fetch(target, {
		method: 'POST',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
			'X-Requested-With': 'XMLHttpRequest',
		},
		body: new URLSearchParams({enabled: enabled ? '1' : '0'}),
	});
	if (!response.ok) {
		throw new Error(`HTTP ${response.status}`);
	}
}

export function setStockOnly(enabled) {
	stockOnly = Boolean(enabled);
	syncControls();
	document.querySelectorAll('[data-color-picker], [data-multi-color-cart]').forEach((container) => {
		container.dispatchEvent(new CustomEvent('color-stock-filter:change', {detail: {enabled: stockOnly}}));
	});
	persist(stockOnly).catch((error) => console.error('Color stock filter could not be saved.', error));
}

export function bindStockToggle(control) {
	if (!once(control, 'color-stock-toggle')) {
		return;
	}
	syncControl(control);
	const eventName = control.matches('input[type="checkbox"]') ? 'change' : 'click';
	control.addEventListener(eventName, () => {
		setStockOnly(control.matches('input[type="checkbox"]') ? control.checked : !isStockOnly());
	});
}

export function bindShowAll(button) {
	if (!once(button, 'color-stock-show-all')) {
		return;
	}
	button.addEventListener('click', () => setStockOnly(false));
}

export function updateHiddenSummary(container, hiddenCount) {
	const summary = container.querySelector('[data-color-stock-hidden]');
	if (!summary) {
		return;
	}
	const visible = isStockOnly() && hiddenCount > 0;
	summary.hidden = !visible;
	const count = summary.querySelector('[data-color-stock-hidden-count]');
	if (count) {
		count.textContent = (getConfig().colorStockFilter?.hiddenCount || '%count%').replace('%count%', String(hiddenCount));
	}
}
